import request from "@/router/axios";


// 获取角色权限
export const getUserRole = (params) => {
  return request({
    url: "/api/th-api/home/querySummury",
    method: "get",
    params: {
      ...params,
    },
  });
};

export const summuryTop = (params) => {
  return request({
    url: "/api/th-api/home/summuryTop",
    method: "get",
    params: {
      ...params,
    },
  });
};
export const summaryCarry = (params) => {
  return request({
    url: "/api/th-api/home/summaryCarry",
    method: "get",
    params: params
  });
};
export const summaryCashGoods = (params) => {
  return request({
    url: "/api/th-api/home/summaryCashGoods",
    method: "get",
    params: {
      ...params,
    },
  });
};
export const summuryBottom = (params) => {
  return request({
    url: "/api/th-api/home/summuryBottom",
    method: "get",
    params: {
      ...params,
    },
  });
};
export const queryHomeMerchantList = (params) => {
  return request({
    url: "/api/th-api/home/queryHomeMerchantList",
    method: "get",
    params: {
      ...params,
    },
  });
};
